import * as React from "react";
import * as $ from 'jquery'
import {
    GoogleReCaptchaProvider,
    GoogleReCaptcha,
} from 'react-google-recaptcha-v3';
import {ReactElement, useState} from "react";
import {Loader} from "./Loader";

interface Result {
    valid: ValidStatus
    className: string
    message: ReactElement
    check: ReactElement
}

enum Status {
    NOT_SEND, SENDING, DONE, ERROR
}

enum ValidStatus {
    VALID, INVALID, UNKNOWN
}

export const Contact : React.FC<{}> = () => {
    const [name, setName] = useState("");
    const [mail, setMail] = useState("");
    const [verify, setVerify] = useState("");
    const [subject, setSubject] = useState("");
    const [text, setText] = useState("");
    const [token, setToken] = useState("");
    const [status, setStatus] = useState<Status>(Status.NOT_SEND);

    function onRecapchaChange(token: any) {
        setToken(token);
    }

    const nameValid = checkName();
    const mailValid = checkEmail();
    const retryValid = checkEmailRetry();
    const subjectValid = checkSubject();
    const textValid = checkText();

    function isValid(): boolean {
        if (status === Status.DONE) {
            return false;
        }
        if (nameValid.valid !== ValidStatus.VALID) {
            return false;
        }
        if (mailValid.valid !== ValidStatus.VALID) {
            return false;
        }
        if (retryValid.valid !== ValidStatus.VALID) {
            return false;
        }
        if (subjectValid.valid !== ValidStatus.VALID) {
            return false;
        }
        if (textValid.valid !== ValidStatus.VALID) {
            return false;
        }
        return true;
    }

    const canSendMail = isValid();
    const buttonEnabled = canSendMail && token.length > 0;
    const buttonClass = buttonEnabled ? "is-primary" : "is-light";

    function checkName(): Result {
        if (name.length === 0) {
            return unknown();
        }
        return valid();
    }

    function checkEmail(): Result {
        if (mail.length === 0) {
            return unknown();
        }
        if (mail.match(/^[A-Za-z0-9]+[\w-]+@[\w\.-]+\.\w{2,}$/)) {
            return valid();
        }
        return invalid("メール形式で入力して下さい");
    }

    function checkEmailRetry(): Result {
        if (verify.length === 0) {
            return unknown();
        }
        if (verify === mail) {
            return valid();
        }
        return invalid("メールアドレスが一致しません");
    }

    function checkSubject(): Result {
        if (subject.length === 0) {
            return unknown();
        }
        if (subject.length > 100) {
            return invalid(`タイトルは100文字以内にして下さい(現在:${text.length}文字)`);
        }
        return valid();
    }

    function checkText(): Result {
        if (text.length === 0) {
            return unknown();
        }
        if (text.length > 500) {
            return invalid(`本文は500文字以内にして下さい(現在:${text.length}文字)`);
        }
        return valid();
    }

    function valid(): Result {
        return {
            valid: ValidStatus.VALID,
            className: "is-success",
            message: null,
            check: (
                <span className="icon is-small is-right">
                  <i className="fas fa-check"/>
                </span>
            )
        }
    }

    function unknown(): Result {
        return {
            valid: ValidStatus.UNKNOWN,
            className: "",
            message: null,
            check: null
        }
    }

    function invalid(message: String): Result {
        return {
            valid: ValidStatus.INVALID,
            className: "is-danger",
            message: (<p className="help is-danger">{message}</p>),
            check: (
                <span className="icon is-small is-right">
                  <i className="fas fa-exclamation-triangle"/>
                </span>
            )
        }
    }

    function sendMail() {
        setStatus(Status.SENDING);
        const sendData = {
            name: name,
            email: mail,
            subject: subject,
            body: text,
            token: token
        };
        $.ajax("https://asia-northeast1-brbranchbiz.cloudfunctions.net/sendMail", {
            dataType: "json",
            contentType: "application/json",
            data: JSON.stringify(sendData),
            scriptCharset: 'utf-8',
            type: "post",
        }).done(() => {
            console.log("done?");
            setStatus(Status.DONE);
        }).fail(() => {
            console.log("error?");
            setStatus(Status.ERROR);
        });
    }

    function showSending() {
        if (status == Status.SENDING) {
            return <div style={{display: "inline-block", height: "40px", padding: "10px 5px"}}><Loader message={"送信中..."}/></div>;
        }
        return null;
    }

    function showError() {
        if (status === Status.DONE) {
            return (
                <div className="notification is-primary">
                    メールを送信しました。
                </div>
            )
        }
        if (status === Status.ERROR) {
            return (
                <div className="notification is-danger">
                    メール送信に失敗しました。 <a href={"https://twitter.com/br_branch"} target={"_blank"}>Twitter</a>で教えてもらえると嬉しいです。
                </div>
            )
        }
        return null;
    }

    function showRecapcha() {
        if (canSendMail) {
            return (
                <GoogleReCaptchaProvider reCaptchaKey="6Le4E-cUAAAAAPl_lLEaqGOg0U_NA8To4WFK5SxJ">
                    <GoogleReCaptcha onVerify={onRecapchaChange} />
                </GoogleReCaptchaProvider>
            );
        }
        return null;
    }

    return (
        <div className={`container contact-root`}>
            <h1 className={"title"}>Contact</h1>
            <div className={"panel contact-panel"}>
                <div className="field is-horizontal">
                    <div className="field-label is-normal">
                        <label className="label">おなまえ</label>
                    </div>
                    <div className="field-body">
                        <div className="field">
                            <div className="control has-icons-left has-icons-right">
                                <input className={"input " + nameValid.className} type="text" placeholder="名前を入力" value={name} onChange={e => {setName(e.target.value)}}/>
                                <span className="icon is-small is-left">
                                  <i className="fas fa-user"/>
                                </span>
                                {nameValid.check}
                            </div>
                            {nameValid.message}
                        </div>
                        <div className="field">
                        </div>
                    </div>
                </div>
                <div className="field is-horizontal">
                    <div className="field-label is-normal">
                        <label className="label">Email</label>
                    </div>
                    <div className="field-body">
                        <div className="field">
                            <div className="control has-icons-left has-icons-right">
                                <input className={"input " + mailValid.className} type="email" placeholder="Email" value={mail} onChange={e => {setMail(e.target.value)}}/>
                                <span className="icon is-small is-left">
                                  <i className="fas fa-envelope"/>
                                </span>
                                {mailValid.check}
                            </div>
                            {mailValid.message}
                        </div>


                        <div className="field">
                            <div className="control has-icons-left has-icons-right">
                                <input className={"input " + retryValid.className} type="email" placeholder="確認用" value={verify} onChange={e => {setVerify(e.target.value)}}/>
                                <span className="icon is-small is-left">
                                  <i className="fas fa-envelope"/>
                                </span>
                                {retryValid.check}
                            </div>
                            {retryValid.message}
                        </div>
                    </div>
                </div>

                <div className="field is-horizontal">
                    <div className="field-label is-normal">
                        <label className="label">題名</label>
                    </div>
                    <div className="field-body">
                        <div className="field">
                            <div className="control has-icons-right">
                                <input className={"input " + subjectValid.className} type="text" placeholder="Subject" value={subject} onChange={e => {setSubject(e.target.value)}}/>
                                {subjectValid.check}
                            </div>
                            {subjectValid.message}
                        </div>
                    </div>
                </div>
                <div className="field is-horizontal">
                    <div className="field-label is-normal">
                        <label className="label">本文</label>
                    </div>
                    <div className="field-body">
                        <div className="field">
                            <div className="control has-icons-right">
                                <textarea className={"textarea " + textValid.className} placeholder="お仕事の引き合いや経歴に関するご質問・業務経歴書の詳細をご希望など記載下さい。" onChange={e => {setText(e.target.value)}} defaultValue={text} />
                                {textValid.check}
                            </div>
                            {textValid.message}
                        </div>
                    </div>
                </div>
                <div className="field is-horizontal">
                    <div className="field-label"/>
                    <div className={"field-body"}>
                        <div className={"field"}>
                            <div className="control">
                                <button className={"button " + buttonClass} disabled={!buttonEnabled} onClick={sendMail}>
                                    送信
                                </button>
                                {showSending()}
                            </div>
                        </div>
                    </div>
                </div>
                {showError()}
            </div>
            {showRecapcha()}
        </div>
    );
};
